import { render, staticRenderFns } from "./radioItemStyle.vue?vue&type=template&id=bf810488&scoped=true"
import script from "./radioItemStyle.vue?vue&type=script&lang=js"
export * from "./radioItemStyle.vue?vue&type=script&lang=js"
import style0 from "./radioItemStyle.vue?vue&type=style&index=0&id=bf810488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf810488",
  null
  
)

export default component.exports